<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.52002 17.4881C4.41902 16.1261 2.99902 14.0941 2.99902 12.0131C2.99902 8.38506 7.327 4.91406 12.004 4.91406C13.988 4.91406 15.913 5.53607 17.469 6.53807"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M9.82481 14.1757C9.24581 13.6027 8.92183 12.8227 8.92483 12.0087C8.92183 10.3117 10.2948 8.9327 11.9918 8.9297C12.8088 8.9277 13.5928 9.2517 14.1708 9.8287"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M19.6711 4.33594L4.33105 19.6759"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M15.0207 12.5547C14.7927 13.8107 13.8097 14.7957 12.5537 15.0267"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M19.7369 8.60938C20.5349 9.65038 21.0019 10.8174 21.0019 12.0134C21.0019 15.6304 16.7129 19.1124 12.0069 19.1124C11.1609 19.1124 10.3339 19.0054 9.5459 18.8004"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
